
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled':isMigrationActive}">
  <div class="row mt-2">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter the Site Name Structure:</p>
      </div>
    </div>
  </div>
  <form [formGroup]="siteNameStructureForm" (ngSubmit)="autoNextStep()">
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="form-group">
          <label for="siteNameStructure">Site Name Structure:</label>
          <input class="form-control" id="siteNameStructure" type="text" formControlName="siteNameStructure" name="siteNameStructure" maxlength="1000">
        </div>
      </div>
    </div>
  </form>
</div>